module.exports = __webpack_public_path__ + "img/stock7.22e1aeda.png";